import React from "react";
import { Modal, Box, Button, IconButton, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { modalStyle } from "../constants";
import { BootstrapButton } from "./BootstrapButton";
 
export default function ConfirmModal({
  open, title, message, warningText, infoText,
  onConfirm, onCancel, loading,
  confirmLabel = "Ya, Lanjutkan", confirmColor,
}) {
  return (
    <Modal open={open} onClose={onCancel}>
      <Box sx={{ ...modalStyle, width: 420, p: 3.5 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{title}</h3>
          <IconButton size="small" onClick={onCancel}><CloseIcon fontSize="small" /></IconButton>
        </div>
 
        <p style={{ color: "#666", fontSize: 13, marginBottom: 12, lineHeight: 1.6 }}>{message}</p>
 
        {warningText && (
          <div style={{ background: "#fff8e1", border: "1px solid #ffe082", borderRadius: 8, padding: "10px 12px", fontSize: 12, color: "#795548", marginBottom: 12 }}>
            ⚠ {warningText}
          </div>
        )}
        {infoText && (
          <div style={{ background: "#e3f2fd", border: "1px solid #90caf9", borderRadius: 8, padding: "10px 12px", fontSize: 12, color: "#1565c0", marginBottom: 12 }}>
            ℹ {infoText}
          </div>
        )}
 
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
          <Button variant="outlined" onClick={onCancel}
            sx={{ textTransform: "none", fontSize: 13, color: "#999", borderColor: "#ddd" }}>
            Batal
          </Button>
          <BootstrapButton
            onClick={onConfirm}
            disabled={loading}
            sx={{
              minWidth: 110,
              ...(confirmColor ? { backgroundColor: confirmColor, "&:hover": { backgroundColor: confirmColor } } : {}),
            }}
          >
            {loading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : confirmLabel}
          </BootstrapButton>
        </div>
      </Box>
    </Modal>
  );
}
 